import SubserviceWrapper from "../../../components/Subservice/SubserviceWrapper";
import services from "../../../service.map";

import "./styles/chpe.styles.css";

export const CHPE = () => {
	return <SubserviceWrapper config={services.chpe} />;
};
